import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ERROR_MESSAGES } from "../GlobalErrorMessage";
import { NewsletterAPI } from "../../ApiServices/NewsLettter/NewsLetterApi";
import SuccessModal from "../SuccessModal";
import logo from "../../assets/images/new/logo (2).png";
import ComingSoonModal from "../ComingSoonModal";
const Footer = () => {
  const [error, setError] = useState(null);
  const location = useLocation();
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(null);
  const [showComingSoonModal, setShowComingSoonModal] = useState(false);
  const userID = localStorage.getItem("userID") || "";
  const [Action, setAction] = useState(false);
  const [newsLetterObj, setNewsLetterObj] = useState({
    firstName: null,
    lastName: null,
    email: null,
  });

  useEffect(() => {
    setInitialData();
  }, [location]);

  const handleSubscribe = () => {
    let isValid = false;
    if (
      newsLetterObj.firstName === "" ||
      newsLetterObj.firstName === null ||
      newsLetterObj.firstName === undefined ||
      newsLetterObj.lastName === "" ||
      newsLetterObj.lastName === null ||
      newsLetterObj.lastName === undefined ||
      newsLetterObj.email === "" ||
      newsLetterObj.email === null ||
      newsLetterObj.email === undefined
    ) {
      setError(true);
      isValid = true;
    } else if (
      newsLetterObj.email !== null &&
      newsLetterObj.email !== undefined &&
      newsLetterObj.email !== "" &&
      !isValidEmail(newsLetterObj.email)
    ) {
      setError(true);
      isValid = true;
    }

    const api_params = {
      FName: newsLetterObj.firstName,
      LName: newsLetterObj.lastName,
      Email: newsLetterObj.email,
      UserID: userID,
    };

    if (!isValid) {
      addUpdateNewsLetter(api_params);
    }
  };

  const addUpdateNewsLetter = async (api_params) => {
    try {
      const res = await NewsletterAPI(api_params);

      if (res.ResponseMessage === "Success") {
        setShowSuccessPopUp(true);
        console.log("done newsletterAdded");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setInitialData = () => {
    setError(false);
    setNewsLetterObj((prev) => ({
      ...prev,
      firstName: "",
      lastName: "",
      email: "",
    }));
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const closeAll = () => {
    // debugger;
    setShowSuccessPopUp(false);
    setInitialData();
    // window.location.reload();
  };

  let date = new Date();
  let n = date.getYear();

  return (
    <footer className="" style={{ backgroundColor: "#A52444" }}>
      <div
        className=""
        style={{
          // backgroundImage: `url('assets/images/backgrounds/footer-bg-1-1.jpg')`,
          position: "absolute",
          width: "100%",
          height: "100%",
          top: 0,
          left: 0,
          backgroundSize: "cover",
          backgroundPosition: "center",
          zIndex: "-1",
        }}
      ></div>

      <div className="" style={{ margin: "20px", marginTop: "0px" }}>
        <div className="row">
          {/* About us */}
          <div
            className="col-12 col-md-12 col-xl-2 wow fadeInUp"
            data-wow-delay="100ms"
          >
            <div className="footer-widget footer-widget--about footert">
              <Link to="/" className="footer-widget__logo">
                <img src={logo} width="223" alt="myom namo" />
              </Link>
              <p className="footer-widget__text">
                Myomnamo is an earnest venture to solve the problem by
                synergizing your spiritual and professional world. We assure to
                bring you closer to the veteran pandit who would guide you in
                the rituals.
              </p>
              <div className="app-buttons-footer text-center w-100">
                <a
                  className="google-play-btn"
                  href="https://play.google.com/store/apps/details?id=spiritualapp.myomnamo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-google-play"></i>
                  <span>
                    Google Play
                  </span>
                </a>
                <a
                  className="app-store-btn"
                  style={{ cursor: 'pointer' }}
                  onClick={() => setShowComingSoonModal(true)}
                // href="http://apps.apple.com/in/app/myomnamo/id6747122767"
                // target="_blank"
                // rel="noopener noreferrer"
                >
                  <i className="fab fa-apple"></i>
                  <span>App Store</span>
                </a>

              </div>
              <div
                className="footer-widget__social"

              >
                <style>{`
    .footer-widget__social a i {
      color: white;
    }
  `}</style>
                <a
                  href="https://www.facebook.com/omnamoapp/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ "--accent-color": "#ffa415" }}
                >
                  <i
                    className="fab fa-facebook-f"
                    aria-hidden="true"
                    target="_blank"
                    rel="noopener noreferrer"
                  ></i>
                  <span className="sr-only">Facebook</span>
                </a>
                <a
                  href="https://www.linkedin.com/company/my-om-namo/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ "--accent-color": "#44c895" }}
                >
                  <i
                    className="fa-brands fa-linkedin"
                    aria-hidden="true"
                    target="_blank"
                    rel="noopener noreferrer"
                  ></i>
                  <span className="sr-only">Instagram</span>
                </a>
                <a
                  href="https://x.com/My_OmNamo"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ "--accent-color": "#44c895" }}
                >
                  <i
                    className="fa-brands fa-x-twitter"
                    aria-hidden="true"
                    target="_blank"
                    rel="noopener noreferrer"
                  ></i>
                  <span className="sr-only">X</span>
                </a>
                <a
                  href="https://www.youtube.com/@myomnamo-beliefredefined9691"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ "--accent-color": "#44c895" }}
                >
                  <i
                    className="fa-brands fa-youtube"
                    aria-hidden="true"
                    target="_blank"
                    rel="noopener noreferrer"
                  ></i>
                  <span className="sr-only">Youtube</span>
                </a>
              </div>
            </div>
          </div>
          {/* Quick links */}
          <div
            className="col-6 col-md-6 col-xl-2 wow fadeInUp"
            data-wow-delay="200ms"
          >
            <div className="footer-widget footer-widget--links-two footert">
              <h2 className="footer-widget__title">Quick Link</h2>
              <ul
                className="list-unstyled footer-widget__links"
                style={{ marginLeft: "3px" }}
              >
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/about-us">About Us</a>
                </li>
                <li>
                  <a href="/spiritual-gyan">Spiritual Gyan</a>
                </li>
                <li>
                  <a href="/faq">FAQs</a>
                </li>
                <li>
                  <a href="/contact-us">Contact Us</a>
                </li>
                <li>
                  <a href="/become-pandit">Become Pandit</a>
                </li>
                <li>
                  <a href="/terms-and-condition">Terms And Conditions</a>
                </li>
                <li>
                  <a href="/Privacy-policy">Privacy Policies</a>
                </li>
                <li>
                  <a href="/refund-policy">Refund Policy</a>
                </li>
              </ul>
            </div>
          </div>
          {/* Services */}
          <div
            className="col-6 col-md-6 col-xl-2 wow fadeInUp"
            data-wow-delay="150ms"
          >
            <div className="footer-widget footer-widget--links footert">
              <h2 className="footer-widget__title">Services</h2>
              <ul
                className="list-unstyled footer-widget__links"
                style={{ marginLeft: "3px" }}
              >
                <li>
                  <Link
                    to="/services/book-puja"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    Puja Booking
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services/daily-booking"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    Daily Puja Booking
                  </Link>
                </li>
                <li>
                  <Link to="/my-store" onClick={() => window.scrollTo(0, 0)}>
                    E-Store
                  </Link>
                </li>

                <li>
                  <Link
                    to="/darshan-booking"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    Darshan Booking
                  </Link>
                </li>
                <li>
                  <Link
                    to="/pooja-at-temple"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    Puja At Temple
                  </Link>
                </li>
                <li>
                  <Link to="/prasad-list" onClick={() => window.scrollTo(0, 0)}>
                    Prasad Booking
                  </Link>
                </li>
                <li>
                  <Link to="/horoscope" onClick={() => window.scrollTo(0, 0)}>
                    Horoscope
                  </Link>
                </li>
                <li>
                  <Link to="/temple" onClick={() => window.scrollTo(0, 0)}>
                    Temples
                  </Link>
                </li>
                <li>
                  <Link to="/services/puja-kit-services " onClick={() => window.scrollTo(0, 0)}>
                    Bhakti Puja Kit
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          {/* Contact Info */}
          <div
            className="col-12 col-md-6 col-xl-2 wow fadeInUp"
            data-wow-delay="250ms"
          >
            <div className="footer-widget footer-widget--contact footert">
              <h2 className="footer-widget__title">Contact Info</h2>
              <ul
                className="list-unstyled footer-widget__info"
                style={{ marginLeft: "0" }}
              >
                <li style={{ "--accent-color": "#ffa415" }}>
                  <span className="footer-widget__info__icon">
                    <i
                      className="icon-phone-call"
                      style={{ color: "white" }}
                    ></i>
                  </span>
                  <a href="tel:+919119555461">+91 9119555461</a>
                </li>
                <li style={{ "--accent-color": "#ffa415" }}>
                  <span className="footer-widget__info__icon">
                    <i
                      className="icon-phone-call"
                      style={{ color: "white" }}
                    ></i>
                  </span>
                  <a href="tel:+917738581133">+91 7738581133</a>
                </li>
                <li style={{ "--accent-color": "#8139e7" }}>
                  <span className="footer-widget__info__icon">
                    <i className="icofont-email" style={{ color: "white" }}></i>
                  </span>
                  <a
                    style={{ color: "white" }}
                    onMouseEnter={(e) => (e.target.style.color = "white")}
                    onMouseLeave={(e) => (e.target.style.color = "white")}
                    href="mailto:info@myomnamo.com"
                  >
                    info@myomnamo.com
                  </a>
                </li>

                <li style={{ "--accent-color": "#ff5528" }}>
                  <span className="footer-widget__info__icon">
                    <i
                      className="icofont-location-pin"
                      style={{ color: "white" }}
                    ></i>
                  </span>
                  Mumbai
                </li>
              </ul>
            </div>
          </div>
          {/* Nes Letter */}
          <div
            className="col-md-6 col-xl-3 wow fadeInUp"
            data-wow-delay="250ms"
          >
            <div className="footer-widget footer-widget--contact footert">
              {/* Newsletter Section */}
              <div
                className="single-nav-area-footer news-letter"
                style={{ marginTop: "20px" }}
              >
                <h2 className="footer-widget__title">Newsletter</h2>
                <p style={{ color: "#f1f1f1", fontSize: "14px" }}>
                  Stay updated with our latest updates.
                </p>
                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                  <input
                    type="text"
                    placeholder="First Name"
                    value={newsLetterObj.firstName}
                    onChange={(e) => {
                      let inputVal = e.target.value;

                      // Allow only letters and spaces (optional)
                      let formattedInput = inputVal.trim().replace(/\s+/g, " ");

                      // Allow empty input so user can delete everything
                      if (
                        formattedInput === "" ||
                        /^[a-zA-Z\s]+$/.test(formattedInput)
                      ) {
                        setNewsLetterObj((prev) => ({
                          ...prev,
                          firstName: formattedInput,
                        }));
                      }
                    }}
                    maxLength={30}
                    style={{
                      flex: "1",
                      padding: "10px",
                      borderRadius: "5px",
                      border: "none",
                      fontSize: "14px",
                      outline: "none",
                    }}
                  />

                  {error &&
                    (newsLetterObj.firstName === "" ||
                      newsLetterObj.firstName === undefined ||
                      newsLetterObj.firstName === null) ? (
                    <span
                      className="error-msg"
                      style={{ lineHeight: "8px", color: "#ff9900" }}
                    >
                      {ERROR_MESSAGES}
                    </span>
                  ) : (
                    ""
                  )}
                  <input
                    type="text"
                    placeholder="Last Name"
                    value={newsLetterObj.lastName}
                    onChange={(e) => {
                      let inputVal = e.target.value;

                      // Format input: remove leading/trailing spaces and reduce multiple spaces to one
                      let formattedInput = inputVal.trim().replace(/\s+/g, " ");

                      // Allow empty input so the user can delete everything
                      if (
                        formattedInput === "" ||
                        /^[a-zA-Z\s]+$/.test(formattedInput)
                      ) {
                        setNewsLetterObj((prev) => ({
                          ...prev,
                          lastName: formattedInput,
                        }));
                      }
                    }}
                    maxLength={30}
                    style={{
                      flex: "1",
                      padding: "10px",
                      borderRadius: "5px",
                      border: "none",
                      fontSize: "14px",
                      outline: "none",
                    }}
                  />
                  {error &&
                    (newsLetterObj.lastName === "" ||
                      newsLetterObj.lastName === undefined ||
                      newsLetterObj.lastName === null) ? (
                    <span
                      className="error-msg"
                      style={{ lineHeight: "8px", color: "#ff9900" }}
                    >
                      {ERROR_MESSAGES}
                    </span>
                  ) : (
                    ""
                  )}
                  <input
                    type="text"
                    placeholder="Email Address"
                    value={newsLetterObj.email}
                    onChange={(e) => {
                      let inputVal = e.target.value;

                      // Allow typing normally but no leading spaces
                      let formattedInput = inputVal.replace(/^\s+/, ""); // Only remove leading spaces, not inside

                      setNewsLetterObj((prev) => ({
                        ...prev,
                        email: formattedInput,
                      }));
                    }}
                    maxLength={50}
                    style={{
                      flex: "1",
                      padding: "10px",
                      borderRadius: "5px",
                      border: "none",
                      fontSize: "14px",
                      outline: "none",
                    }}
                  />
                  {error &&
                    (newsLetterObj.email === "" ||
                      newsLetterObj.email === undefined ||
                      newsLetterObj.email === null) ? (
                    <span
                      className="error-msg"
                      style={{ lineHeight: "8px", color: "#ff9900" }}
                    >
                      {ERROR_MESSAGES}
                    </span>
                  ) : error && !isValidEmail(newsLetterObj.email) ? (
                    <span style={{ lineHeight: "8px", color: "#ff9900" }}>
                      Please enter a valid email
                    </span>
                  ) : (
                    ""
                  )}
                  <div style={{ width: "100%" }}>
                    <button
                      onClick={handleSubscribe}
                      className="btn-subscribe"
                      style={{
                        backgroundColor: "#ff9900",
                        color: "#000000",
                        border: "none",
                        padding: "10px 15px",
                        borderRadius: "5px",
                        // width:'20vw',
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                    >
                      Subscribe
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="main-footer__bottom wow fadeInUp" data-wow-delay="300ms">
        <div>
          <div className="main-footer__bottom__inner">
            <p className="main-footer__copyright">
              &copy; Copyright {new Date().getFullYear()}{" "}
              <span className="dynamic-year"></span> By Myomnamo
            </p>
          </div>
        </div>
      </div>
      <SuccessModal
        show={showSuccessPopUp}
        onHide={() => {
          setInitialData();
          setShowSuccessPopUp(false);
        }}
        onConfirm={closeAll}
        Action={null}
      />
      <ComingSoonModal
        show={showComingSoonModal}
        onClose={() => setShowComingSoonModal(false)}
      />
    </footer>
  );
};

export default Footer;
